import { EmployeeTransfersService } from "./../../../services/documents/EmployeeTransfersService";
import React from "react";
import { EmployeeTransfersDetail } from "../../../components/Pages/Documents/EmployeeTransfers/EmployeeTransfersDetail";
import { IAppEntity } from "../../entities";
import { DocumentService } from "../../../services/documents/DocumentService";
import { CreateEmployeeTransfersDto } from "../../../dtos/documents/EmployeeTransfers/CreateEmployeeTransfersDto";
import { ReferenceTypes } from "../../../enums/ReferenceTypes";
import { NFLookupEmployeeTransfers } from "../../../components/Shared/NewForms/NFLookupEmployeeTransfers";
import EmployeeTransfersList from "../../../components/Pages/Documents/EmployeeTransfers/EmployeeTransfersList";

export const EmployeeTransfers: IAppEntity = {
  entityType: "document",
  title: "Employee Transfers",
  pluralTitle: "Employee Transfers",
  apiUrl: "EmployeeTransfers",
  apiEnum: ReferenceTypes.DocumentEmployeeTransfer,
  getDetailViewComponent: (
    model: any,
    modelUpdatedEvent: (model: any) => void
  ) =>
    React.createElement(EmployeeTransfersDetail, {
      model: model,
      modelUpdatedEvent: modelUpdatedEvent,
    }),
  getListView: (model: any, modelUpdatedEvent: (model: any) => void) =>
    React.createElement(EmployeeTransfersList, {
      model: model,
      modelUpdatedEvent: modelUpdatedEvent,
    }),
  getLookupComponent(model: any): any {
    return React.createElement(NFLookupEmployeeTransfers, {
      fieldName: model.fieldName,
      title: model.title,
      setSelectedCatalog: model.setSelectedCatalog,
    });
  },
  getDataService: () => new EmployeeTransfersService("EmployeeTransfers"),
  getEmptyModel: () => {
    const model: CreateEmployeeTransfersDto = {
      totalAmount: 0,
      totalAmountVat: 0,
      status: 0,
      documentNumber: "",
      documentDate: new Date(),
      departureDate: new Date(),
      transferDate: new Date(),
      createdDate: new Date(),
    };
    return model;
  },
};
